import styled, { css } from 'styled-components'
import { Select } from 'antd'

const invalid = (props) => {
  if (props.invalid) {
    return css`
      border-color: rgb(255, 0, 0, 1);
      box-shadow: none;

      &:hover,
      &:focus {
        border-color: rgb(255, 0, 0, 1);
        box-shadow: 0 0 0 2px rgb(255, 0, 0, 0.5);
      }
    `
  }
}

export const StyledSelect = styled(Select)`
  width: 100%;
  border-radius: 2px;
  ${invalid}
`

export const CreateSection = styled.div`
  margin-top: 8px;
  padding: 12px;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
`

export const LogoUploadWrapper = styled.div`
  margin-bottom: 8px;

  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload.ant-upload-select-picture-card {
    width: 80px;
    height: 80px;
  }
`
